export default __webpack_public_path__ + "static/media/image-study-board-1-m@2x.9302e89c.webp";